import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M12 20.25H6c-1.577 0-2.25-.673-2.25-2.25V6c0-1.577.673-2.25 2.25-2.25h5.25V6c0 2.418 1.332 3.75 3.75 3.75h2.25V12a.75.75 0 0 0 1.5 0V9a.75.75 0 0 0-.22-.53l-6-6a.75.75 0 0 0-.53-.22H6C3.582 2.25 2.25 3.582 2.25 6v12c0 2.418 1.332 3.75 3.75 3.75h6a.75.75 0 0 0 0-1.5M12.75 6V4.811l3.439 3.439H15c-1.577 0-2.25-.673-2.25-2.25M14 12.75H7a.75.75 0 0 1 0-1.5h7a.75.75 0 0 1 0 1.5m-7 4a.75.75 0 0 1 0-1.5h4a.75.75 0 0 1 0 1.5zm15.53 4.72-1.55-1.55a3.64 3.64 0 0 0 .603-2.003 3.67 3.67 0 0 0-3.666-3.667 3.67 3.67 0 0 0-3.667 3.667 3.67 3.67 0 0 0 3.667 3.667c.74 0 1.426-.224 2.003-.602l1.55 1.549a.75.75 0 0 0 1.06 0 .75.75 0 0 0 0-1.061m-6.78-3.553a2.17 2.17 0 0 1 2.167-2.167 2.17 2.17 0 0 1 2.166 2.167 2.17 2.17 0 0 1-2.166 2.167 2.17 2.17 0 0 1-2.167-2.167"
    }, null, -1)
  ])))
}
export default { render: render }